import React from 'react';
import { ShieldCheck, Activity, Sparkles } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const ExpertPetCarePage = () => {
  const config = {
    badge: "Clinical Philosophy",
    headline: "Expert Pet",
    headlineItalic: "Care.",
    subtext: "Rooted in compassion, elevated by expertise — the philosophy that guides every clinical decision and every patient interaction at our sanctuary.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Expert Pet Care at Dr. Suresh Pet Care — Clinical Excellence Philosophy",
    stats: [
      { value: 20000, suffix: '+', label: 'Patients Served' },
      { value: 10, suffix: '+', label: 'Years Experience' },
      { value: 15, suffix: '+', label: 'Clinical Specialities' },
      { value: 24, suffix: '/7', label: 'Always Available' },
    ],
    services: [
      {
        title: "Multi-Speciality Access",
        icon: <ShieldCheck size={28} />,
        desc: "One-stop access to 15+ veterinary specialities under a single trusted clinical roof in Hyderabad.",
        specs: ["Cardiology", "Oncology", "Orthopaedics", "Internal Medicine"],
        color: "from-blue-500/10 to-primary/10"
      },
      {
        title: "Clinical Excellence",
        icon: <Activity size={28} />,
        desc: "Evidence-based medicine, modern equipment, and continuous clinical education drive every diagnosis and treatment.",
        specs: ["Latest Protocols", "Continuing Education", "International Standards", "Gold-Standard Care"],
        color: "from-primary/10 to-green-500/10"
      },
      {
        title: "Compassionate Care",
        icon: <Sparkles size={28} />,
        desc: "Beyond clinical excellence — a genuine commitment to emotional support for both pets and their families.",
        specs: ["Family Communication", "Comfort Care", "Transparent Counseling", "Empathetic Approach"],
        color: "from-amber-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Care",
    sectionItalic: "Philosophy.",
    warningTitle: "Why Choose",
    warningItalic: "Dr. Suresh Pet Care.",
    warningText: "When it comes to your pet's health, only the best will do. Here's what sets our clinical sanctuary apart from ordinary veterinary clinics.",
    warnings: [
      { name: "In-House Lab & Imaging", desc: "No referrals — CT, ultrasound, bloodwork, and X-ray all under one roof.", icon: "🏥" },
      { name: "24/7 Emergency", desc: "Our emergency team never sleeps. Critical care and ambulance services around the clock.", icon: "🚨" },
      { name: "15+ Specialities", desc: "From cardiology to exotic care — comprehensive expertise available on-site daily.", icon: "⭐" },
      { name: "Trusted by Thousands", desc: "20,000+ patients and counting — Hyderabad's most trusted veterinary sanctuary.", icon: "❤️" },
    ],
    ctaBadge: "Expert Clinical Care",
    ctaTitle: "The Expert Care",
    ctaItalic: "Difference.",
    ctaText: "Dr. T Suresh Babu and his dedicated team bring Hyderabad's most comprehensive veterinary expertise to every patient, every day, with heart and precision.",
    ctaBtn: "Experience Expert Care",
    seoText: "Expert pet care in Hyderabad. Multi-speciality veterinary sanctuary led by Dr. T Suresh Babu. 24/7 emergency, 15+ specialities, and advanced diagnostics.",
    glowColor: "amber-500"
  };

  return (
    <>
      <SEO 
        title="Expert Pet Care — Dr. Suresh Sanctuary"
        description="Discover the philosophy, expertise, and compassionate clinical approach that defines Dr. Suresh Pet Care as Hyderabad's leading veterinary sanctuary."
        canonical="/expert-pet-care"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default ExpertPetCarePage;
